import { createSlice } from '@reduxjs/toolkit';
import type { SavedPaymentMethodWithMeta } from '@appTypes';
import {
  fetchSavedPaymentMethods,
  markSavedPaymentMethodPrimary,
  removeSavedPaymentMethod,
} from './actions';
import { removeId, removeById, setPrimary } from './utils';

export type State = {
  isFetched: boolean;
  deletedIDsQueue: string[];
  managedPaymentMethodId?: string;
  savedPaymentMethods?: SavedPaymentMethodWithMeta[];
};

export const initialState: State = {
  isFetched: false,
  deletedIDsQueue: [],
};

const savedPaymentMethodsSlice = createSlice({
  name: 'savedPaymentMethods',
  initialState,
  reducers: {
    setManagedMethodId: (state, action) => {
      state.managedPaymentMethodId = action.payload;
    },
    setMethodPrimary: (state, action) => {
      if (state.savedPaymentMethods) {
        setPrimary(state.savedPaymentMethods, action.payload);
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(markSavedPaymentMethodPrimary.fulfilled, (state, action) => {
        const { paymentMethodId } = action.meta.arg;

        if (state.savedPaymentMethods) {
          setPrimary(state.savedPaymentMethods, paymentMethodId);
        }
      })

      .addCase(fetchSavedPaymentMethods.pending, (state) => {
        state.isFetched = false;
      })
      .addCase(fetchSavedPaymentMethods.rejected, (state) => {
        state.isFetched = true;
      })
      .addCase(fetchSavedPaymentMethods.fulfilled, (state, action) => {
        state.savedPaymentMethods = action.payload;
        state.isFetched = true;
      })

      .addCase(removeSavedPaymentMethod.pending, (state, action) => {
        state.deletedIDsQueue.push(action.meta.arg.paymentMethodId);
      })
      .addCase(removeSavedPaymentMethod.rejected, (state, action) => {
        state.deletedIDsQueue = removeId(
          state.deletedIDsQueue,
          action.meta.arg.paymentMethodId,
        );
      })
      .addCase(removeSavedPaymentMethod.fulfilled, (state, action) => {
        const { paymentMethodId } = action.meta.arg;
        const { savedPaymentMethods } = state;

        if (savedPaymentMethods) {
          state.savedPaymentMethods = removeById(
            savedPaymentMethods,
            paymentMethodId,
          );
        }

        state.deletedIDsQueue = removeId(
          state.deletedIDsQueue,
          action.meta.arg.paymentMethodId,
        );
      });
  },
});

export const {
  reducer: savedPaymentMethodsReducer,
  actions: savedPaymentMethodsActions,
} = savedPaymentMethodsSlice;
